module.exports = __webpack_public_path__ + "static/media/HAPAG-LLOYD.69b84412.svg";